import React, {useState, useEffect} from 'react';
import './App.css';

import Header from './components/Header';
import Form from './components/Form';
import TodoList from './components/TodoList';

function App() {
  const[inputText, setInputText] = useState("");
  const[todos, setTodos] = useState([]);
  const[status, setStatus] = useState("all");
  const[filteredTodos, setFilteredTodos] = useState([]);

  useEffect(() => {
    filterHandler();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [todos, status]);
  
  const filterHandler = () => {
    switch(status) {
      case 'completed':
        setFilteredTodos(todos.filter(todo => todo.completed === true));
        break;
      case 'uncompleted':
        setFilteredTodos(todos.filter(todo => todo.completed === false));
        break;
      default:
        setFilteredTodos(todos);
        break;
    }
  }

  return (
      <div className="App">
        <Header/>
        <Form 
        inputText={inputText} 
        todos={todos} 
        setTodos={setTodos} 
        setInputText={setInputText} 
        setStatus={setStatus} 
        />
        <TodoList 
        setTodos={setTodos} 
        todos={todos} 
        filteredTodos={filteredTodos}/>
      </div>
  );
}

export default App;
